import { format, isValid } from "date-fns";
import type { ReactNode } from "react";

export const formatChatSearchDate = (updatedAt: string): string => {
  const date = new Date(updatedAt);
  if (!isValid(date)) {
    return "";
  }

  const dateFormat =
    date.getFullYear() === new Date().getFullYear() ? "MMM d" : "MMM d yyyy";
  return format(date, dateFormat);
};

const stripSearchMarkup = (value: string): string =>
  value.replace(/<[^>]*>/g, "");

export const renderChatSearchTitle = (
  title: string,
  searchMatch: string | null | undefined,
): ReactNode => {
  if (!searchMatch) {
    return title;
  }

  const nodes: ReactNode[] = [];
  const markRegex = /<mark>(.*?)<\/mark>/gi;
  let lastIndex = 0;
  let hasHighlight = false;

  for (
    let match = markRegex.exec(searchMatch);
    match !== null;
    match = markRegex.exec(searchMatch)
  ) {
    const beforeMatch = stripSearchMarkup(
      searchMatch.slice(lastIndex, match.index),
    );
    if (beforeMatch) {
      nodes.push(beforeMatch);
    }

    const highlightedText = stripSearchMarkup(match[1] ?? "");
    if (highlightedText) {
      nodes.push(
        <span key={`highlight-${match.index}`} className="font-semibold">
          {highlightedText}
        </span>,
      );
      hasHighlight = true;
    }

    lastIndex = match.index + match[0].length;
  }

  const afterLastMatch = stripSearchMarkup(searchMatch.slice(lastIndex));
  if (afterLastMatch) {
    nodes.push(afterLastMatch);
  }

  return hasHighlight ? nodes : stripSearchMarkup(searchMatch) || title;
};
